import { gql } from '@apollo/client';

export default gql`
  mutation confirmBooking($bookingReference: String!) {
    confirmBooking(bookingReference: $bookingReference) {
      reference
    }
  }
`;
